class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.overlay = document.getElementById('cart-notification-overlay');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.onOverlayClick = this.close.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.overlay.classList.add('active');
    this.notification.classList.add('active');
    document.body.style.overflow = 'hidden';

    this.overlay.addEventListener('click', this.onOverlayClick);

    setTimeout(() => {
      this.notification.focus();
      trapFocus(this.notification);
    }, 300);

    document.body.addEventListener('click', this.onBodyClick);
    this.trackPopupButtons();

    // Track popup impression
    if (typeof gtag === 'function') {
      const productEl = this.notification.querySelector('.cart-notification-product');
      const productTitle = productEl?.querySelector('.cart-notification-product__name')?.textContent?.trim() || '';
      const productPrice = productEl?.querySelector('.cart-notification-product__price')?.textContent?.trim() || '';
      gtag('event', 'atc_popup_shown', {
        product_title: productTitle,
        product_price: productPrice,
      });
    }
  }

  trackPopupButtons() {
    if (typeof gtag !== 'function') return;

    const checkoutBtn = this.notification.querySelector('.cart-notification__btn--checkout');
    const viewCartBtn = this.notification.querySelector('.cart-notification__btn--view-cart');
    const continueBtn = this.notification.querySelector('.cart-notification__continue');

    const productEl = this.notification.querySelector('.cart-notification-product');
    const productTitle = productEl?.querySelector('.cart-notification-product__name')?.textContent?.trim() || '';
    const productPrice = productEl?.querySelector('.cart-notification-product__price')?.textContent?.trim() || '';

    if (checkoutBtn && !checkoutBtn._gaTracked) {
      checkoutBtn.addEventListener('click', () => {
        gtag('event', 'atc_popup_checkout', {
          button_text: 'Secure Checkout',
          product_title: productTitle,
          product_price: productPrice,
        });
      });
      checkoutBtn._gaTracked = true;
    }

    if (viewCartBtn && !viewCartBtn._gaTracked) {
      viewCartBtn.addEventListener('click', () => {
        gtag('event', 'atc_popup_view_cart', {
          button_text: 'View Cart',
          product_title: productTitle,
          product_price: productPrice,
        });
      });
      viewCartBtn._gaTracked = true;
    }

    if (continueBtn && !continueBtn._gaTracked) {
      continueBtn.addEventListener('click', () => {
        gtag('event', 'atc_popup_continue', {
          button_text: 'Continue Shopping',
          product_title: productTitle,
          product_price: productPrice,
        });
      });
      continueBtn._gaTracked = true;
    }

    // Close button (X) tracking
    const closeBtn = this.notification.querySelector('.cart-notification__close');
    if (closeBtn && !closeBtn._gaTracked) {
      closeBtn.addEventListener('click', () => {
        gtag('event', 'atc_popup_close', {
          close_method: 'close_button',
          product_title: productTitle,
          product_price: productPrice,
        });
      });
      closeBtn._gaTracked = true;
    }

    // Overlay click tracking
    if (this.overlay && !this.overlay._gaTracked) {
      this.overlay.addEventListener('click', () => {
        gtag('event', 'atc_popup_close', {
          close_method: 'overlay_click',
          product_title: productTitle,
          product_price: productPrice,
        });
      });
      this.overlay._gaTracked = true;
    }

    // Escape key tracking
    if (!this.notification._gaEscTracked) {
      this.notification.addEventListener('keyup', (evt) => {
        if (evt.code === 'Escape') {
          gtag('event', 'atc_popup_close', {
            close_method: 'escape_key',
            product_title: productTitle,
            product_price: productPrice,
          });
        }
      });
      this.notification._gaEscTracked = true;
    }
  }

  close() {
    this.notification.classList.remove('active');
    this.overlay.classList.remove('active');
    document.body.style.overflow = '';

    this.overlay.removeEventListener('click', this.onOverlayClick);
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification') && !target.closest('.cart-notification__modal')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
